import { AuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { TokenClaims } from '@azure/msal-common';

// Interface for agent verification
export interface IAgentVerificationResult {
  agentId: string;
}

// Enum for MSAL statuses related to B2C custom errors
export enum EMSALStatus {
  FORGOT_PASSWORD = 'AADB2C90118',
  PASSWORD_EXPIRED = 'AADSTS50055',
  SESSION_TIME_OUT = 'AADB2C90077',
  CANCEL_RESET_PASSWORD = 'AADB2C90091',
  MULTIPLE_ACCOUNTS = 'AADB2C90273',
}

// Cache result interface (consider removing if MSAL 3.0 manages tokens natively)
export interface ICacheResult {
  errorDesc: string;
  token: string;
  error: string;
}

// Interface for storing tokens (handled via MSAL 3.0 storage management)
export interface IMsalStoredToken {
  accessToken: string;
  idToken: string;
  expiresIn: string;
  clientInfo: string;
}

// Enum for MSAL item types (login success/failure, token acquire events)
export enum EMsalItemType {
  LOGIN_FAILURE = 'msal:loginFailure',
  LOGIN_SUCCESS = 'msal:loginSuccess',
  ACQUIRE_TOKEN_SUCCESS = 'msal:acquireTokenSuccess',
  ACQUIRE_TOKEN_FAILURE = 'msal:acquireTokenFailure',
}

// MsalItem interface (using AuthError instead of MSALError)
export interface MsalItem {
  type: string;
  payload: AuthError | InteractionRequiredAuthError; // Adjusted for MSAL 3.0
}

// User interface for handling token claims
export interface IUser {
  [x: string]: any;
  // Identifiers and basic info
  homeAccountId: string; // Home account identifier
  environment: string; // Issuer's domain
  tenantId: string; // Tenant ID
  localAccountId: string; // Local account identifier
  username: string; // Preferred username
  name?: string; // Full name
  idToken?: string; // Raw ID token
  idTokenClaims?: TokenClaims & {
    [key: string]: string | number | string[] | object | undefined | unknown;
  };
  nativeAccountId?: string; // Native account ID
  roles: string | string[]; // User roles
  rolesOnly: string[]; // Array of roles only
  permissionsOnly: string[]; // Array of permissions only
  emails: string[];
  // Additional properties
  city: string; // User's city
  aud: string; // Audience claim
  auth_time: number; // Authentication time
  exp: number; // Expiration time
  iat: number; // Issued at time
  iss: string; // Issuer
  nbf: number; // Not before
  nonce: string; // Nonce
  tfp: string; // Trust Framework Policy
  ver: string; // Version
  oid?: any;
}

export interface IAuthUser {
  Email: string;
  Role: string;
  Name?: string;
  Oid?: string;
}
